import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../../../general/Button";
import config from "../../../../../config/channels";
import useOperatorContext from "../../../../../contexts/operator/useOperatorContext";
import useSiteContext from "../../../../../contexts/site/useSiteContext";
import TinyModal from "../../../../general/TinyModal";

type AllergyInfoModalProps = {
    show: boolean;
    onHide: () => void;
    onContinue: () => void;
};

const AllergyInfoModal = ({
    show,
    onHide,
    onContinue,
}: AllergyInfoModalProps) => {

    const operatorContext = useOperatorContext();
    const siteContext = useSiteContext();
    const isDineIn = siteContext.channel === config.dineIn.name;

    useEffect(() => {
        document.getElementById('allergy-info-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('allergy-info-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const renderFooter = () => (
        <>
            <CTA secondary buddies
                 onClick={onHide}>
                <span>Go back</span>
            </CTA>
            <CTA buddies
                 onClick={onContinue}>
                <span>Continue</span>
            </CTA>
        </>
    );

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            backdropClassName="modal-allergy-info-backdrop"
            className="allergy-info-modal-dialog"
            header="Allergen advice"
            footer={renderFooter()}
            modalID={'allergy-info-modal'}
        >
           <p dangerouslySetInnerHTML={{ __html: isDineIn ? (operatorContext.operator?.theme.v4.allergen_info_onsite ?? '') : (operatorContext.operator?.theme.v4.allergen_info ?? '') }}></p>
        </TinyModal>
    );
};

export default AllergyInfoModal;
